import { render } from "./MobileHelper.vue?vue&type=template&id=084c3bfc&scoped=true"
import script from "./MobileHelper.vue?vue&type=script&lang=js"
export * from "./MobileHelper.vue?vue&type=script&lang=js"

import "./MobileHelper.vue?vue&type=style&index=0&id=084c3bfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084c3bfc"]])

export default __exports__